import React from "react";

function FinalOrder() {
  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          {/* ================= SUCCESS HEADER ================= */}
          <div className="text-center p-4 border rounded-3 mb-4">
            <div
              className="mx-auto mb-3 d-flex align-items-center justify-content-center"
              style={{
                width: "70px",
                height: "70px",
                borderRadius: "50%",
                backgroundColor: "#3ad97a",
                color: "#fff",
                fontSize: "32px",
              }}
            >
              ✓
            </div>

            <h4 className="fw-bold text-success mb-2">
              Order confirmed
            </h4>

            <p className="mb-0 text-muted">
              Your order <strong>ORD-62</strong> is confirmed. You will receive
              an order confirmation email/SMS shortly with the expected delivery
              date.
            </p>
          </div>

          {/* ================= DELIVERY DETAILS ================= */}
          <div className="border rounded-3 p-4 mb-4">
            <div className="row align-items-center">
              <div className="col-md-9">
                <p className="mb-1 text-muted">Delivering to:</p>
                <h6 className="fw-bold mb-2">Prajwal Puntakar</h6>

                <span className="text-danger fw-semibold d-block mb-1">
                  ORDER DETAILS
                </span>

                <small className="text-muted">
                  You can track / View / Modify order from orders page.
                </small>
              </div>

              <div className="col-md-3 text-end">
                <span style={{ fontSize: "40px" }}>🚚</span>
              </div>
            </div>
          </div>

          {/* ================= PAY LATER ================= */}
          <div className="border rounded-3 p-4">
            <div className="row align-items-center">
              <div className="col-md-9">
                <h6 className="fw-bold mb-1">
                  Now pay at your convenience
                </h6>
                <p className="mb-1">
                  Pay online using Pay Now option from orders or Pay on Delivery
                  (Cash/UPI).
                </p>
                <a href="#" className="text-danger fw-semibold">
                  See How
                </a>
              </div>

              <div className="col-md-3 text-end">
                <span style={{ fontSize: "40px" }}>💳</span>
              </div>
            </div>
          </div>

          {/* ================= HOME BUTTON ================= */}
          <div className="text-center mt-4">
            <button className="bg-col text-white border-0 px-5 py-2 fw-bold rounded-2">
              GO TO HOME
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FinalOrder;
